exports.SITE_TITLE = 'Lessons in Courseware Development'
exports.SITE_DESCRIPTION = 'Inspiring the future of courseware built for impact and sustainability'
